<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      logtype:'日志管理',
      table: {
        mname: "backstageLog",
        key: "id",
        url: {
        },
        output: false,
        order:'id',
        qrCode: "qrCode",
      },
      // actions: [
      //   {
      //     label: "新增日志",
      //     icon: "md-add",
      //     onClick: this.toAdd,
      //     auth: "/admin/backstageLog/add",
      //     type: "success",
      //   },
      // ],
      menus: [
        // { label: "商品管理", name: "commodity_list", auth: "/admin/commodity/list"},
        // { label: "分类管理", name: "commodityType_list", auth: "/admin/commodityType/list"},
        // { label: "标签管理", name: "labelType_list", auth: "/admin/labelType/list"},
        // { label: "日志管理", name: "logType_list", auth: "/admin/logType/list"},
        // { label: "物流管理", name: "logisticsType_list", auth: "/admin/logisticsType/list"},
        // { label: "订单管理", name: "ordersType_list", auth: "/admin/ordersType/list"},
      ],
      query: {
        //state: 2,
      },
      filters: [
      {label: '操作单元', name: 'workshop', value: '', type: 'input'},
        // { label: "商品名称", name: "commodityName", value: "", type: "select" },
        // {
        //   label: "标签分类",
        //   name: "logType",
        //   value: "",
        //   type: "select",
        //   dropList: [
        //     { value: 1, name: "医用耗材" },
        //     { value: 2, name: "电子设备" },
        //   ],
        // },
      ],
      tableCols: [
        // {
        //   type: "selection",
        //   width: 60,
        // },
        // {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "left",
        // },
        {
          title: "日志编号",
          key: "id",
          minWidth: 100,
          align: "center",
        },
        {
          title: "操作模块",
          key: "workshop",
          minWidth: 100,
          align: "center",

        },
        {
          title: "日志时间",
          align: "center",
          minWidth: 350,
          key: "createTime",
          // fixed: "right",
          // handle: [
          //   "edit",
          // ],
          // auth: {
          //   edit: "/admin/commodityType/edit",
          // },

        },
        {
          title: "操作类型",
          key: "backstageLogDetail",
          width: 260,
          align: "center",
          render:(h,p) =>{
              const status=p.row.backstageLogDetail
              const text =
                status == 0 ? "其他" : 
                status == 1 ? "新增" :
                status == 2 ? "修改" : 
                status == 3 ? "删除" : 
                status == 4 ? "授权" : 
                status == 5 ? "导出" : 
                status == 6 ? "导入" : 
                status == 7 ? "强退" : 
                status == 8 ? "生成代码" : 
                status == 9 ? "清空数据" :  
                "";
              return (
                <p>{text}</p>
              );
            },
          
        },
        
        // {
        //   title: "库存数量",
        //   key: "",
        //   minWidth: 160,
        //   align: "center",  
        // },
        {
          title: "操作人",
          key: "createBy",
          minWidth: 160,
          align:"center",
        },
      ],
    };
  },
  created() {
  },
  methods: {

    toAdd() {
      $utils.url.push({ name: "logType_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "logType_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>

